import React from 'react'
import { Grid } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import useBiteClassification from 'hooks/useBiteClassification'
import { useFetchLatestBiteClassificationQuery } from 'store/modules/BiteClassification'
import BiteClassification from 'components/Patients/BiteClassification/BiteClassification'
import BaseCopilotInsightWidget from './common/BaseCopilotInsightWidget'
import DazzedParagraph12 from 'components/common/text/DazzedParagraph12'

const LatestBiteClassification = () => {
  const { t } = useTranslation()
  const { isEnabled } = useBiteClassification()
  const patientId = useSelector(state => state.patientsReducer.patient?.id)
  const { currentData, isFetching, isError } = useFetchLatestBiteClassificationQuery(
    { patientId },
    { skip: !patientId || !isEnabled, refetchOnMountOrArgChange: true }
  )
  if (!isEnabled || (!isFetching && !isError && !currentData)) return null
  return (
    <Grid item>
      <BaseCopilotInsightWidget>
        {isFetching ? (
          <Skeleton height={70} />
        ) : isError ? (
          <DazzedParagraph12>{t('biteClassification.loadError')}</DazzedParagraph12>
        ) : (
          <BiteClassification
            variant="copilot"
            value={currentData.biteClassification}
            title={t('biteClassification.latestTitle')}
          />
        )}
      </BaseCopilotInsightWidget>
    </Grid>
  )
}

export default LatestBiteClassification
